module.exports = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
};
